






import { Component, Vue } from "vue-property-decorator";
import BaseView from "@/components/Base/Elements/BaseView.vue";
import UserLoginForm from "@/components/User/UserLoginForm.vue";

@Component({
  extends: BaseView,
  components: {
    UserLoginForm
  }
})
export default class LoginView extends Vue {}
